import { useParams } from 'react-router-dom';

import { NotFound } from '@/components/molecules/NotFound';
import { BioscopeDetailContainer } from '@/routes/shared/BioscopeDetailContainer';
import { parsePositiveInt } from '@/utils/parsePositiveInt';

function CageBioscopeDetailContainer() {
    const bioscopeId = parsePositiveInt(useParams().bioscopeId);

    if (bioscopeId == null) {
        return <NotFound />;
    }

    return <BioscopeDetailContainer bioscopeId={bioscopeId} />;
}

export default CageBioscopeDetailContainer;
export { CageBioscopeDetailContainer };
